module.exports = __webpack_public_path__ + "static/media/bind.0bcd1972.gif";